"use client";

import { Modal, ModalHeader, ModalBody } from "reactstrap";
import DaumPostcode from "react-daum-postcode";
import axios from "axios";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  setValue: any;
}
export function AddressSearchModal({ isOpen, onClose, setValue }: Props) {
  const handleComplete = async (data: any) => {
    // setAddress(data.address);
    // setZonecode(data.zonecode);

    const headers = {
      Authorization: `KakaoAK 6880ed5cd83735b3412295ff17b43e0b`,
    };
    const response = (await axios.get(
      `https://dapi.kakao.com/v2/local/search/address.json?query=${encodeURI(
        data.roadAddress
      )}`,
      { headers }
    )) as any;

    setValue("zipcode", response.data.documents[0].road_address.zone_no);
    setValue("address", response.data.documents[0].road_address.address_name);
    setValue("longitude", response.data.documents[0].x);
    setValue("latitude", response.data.documents[0].y);
    onClose();

    // const result = (await axios.get(
    //   `https://dapi.kakao.com/v2/local/search/address.json?query=${encodeURI(
    //     roadAddress
    //   )}`,
    //   { headers }
    // )) as any;

    // if (result.status === 200 && result.data.documents.length > 0) {
    // }

    // const url = `https://dapi.kakao.com/v2/local/search/address.json?query=${encodeURI(
    //   roadAddress
    // )}`;
    // const params = {
    //   startX: startX,
    //   startY: startY,
    //   endX: endX,
    //   endY: endY,
    //   startName: startName,
    //   endName: endName,
    // };
    // const response = await fetch(url, {
    //   method: "POST",
    //   headers: {
    //     "Content-Type": "application/json",
    //   },
    //   body: JSON.stringify(params),
    // });
  };

  return (
    <Modal isOpen={isOpen} toggle={onClose}>
      <ModalHeader toggle={onClose}>주소 검색</ModalHeader>
      <ModalBody className="p-0">
        <DaumPostcode onComplete={handleComplete} />
      </ModalBody>
    </Modal>
  );
}
